export const BREAKPOINTS = {
  TABLET: 950,
  MOBILE: 790,
  MOBILE_SM: 490
};
